class ResourceGroup {
    static getSearchKey() {
        return 'name';
    }

    static fromRaw(raw) {
        let resourceGroup = new ResourceGroup();
        resourceGroup.uuid = raw.uuid;
        resourceGroup.name = raw.name;
        resourceGroup.state = raw.state;
        // subscription.accountId = raw.procurementAccountId;
        // subscription.isBillingAccountViewer = raw.isCurrentUserBillingAccountViewer;
        // subscription.managerUrl = raw.managerUrl;

        return resourceGroup;
    }
}

module.exports = ResourceGroup;



// WEBPACK FOOTER //
// ./src/azurebackup/model/ResourceGroup.js